// components/FooterSection.tsx
import { Heart } from "lucide-react";

export default function FooterSection() {
  return (
    <footer className="bg-white py-12 px-6">
      <div className="max-w-4xl mx-auto text-center">
        {/* Divider */}
        <div className="flex items-center justify-center gap-3 my-6">
          <div className="w-16 h-px bg-gray-300"></div>
          <Heart className="w-4 h-4 text-[#C49355]" fill="#C49355" />
          <div className="w-16 h-px bg-gray-300"></div>
        </div>

        {/* Message */}
        <p
          className="text-gray-600 text-sm"
          style={{
            fontFamily: "'Times New Roman', Times, serif",
          }}
        >
          We can't wait to celebrate with you!
        </p>

        {/* Copyright */}
        <p className="text-gray-400 text-xs mt-8">
          © {new Date().getFullYear()} J & J Wedding
        </p>
      </div>
    </footer>
  );
}
